import type { Owner } from "src/business/account/owner";
import { isFeatureEnabled } from "src/helpers/FeatureCapabilityConfig";

/**
 * How far into the calendar a restaurant may look.
 *
 * The booking module is sold in two slices. `visibilite` grants
 * `same_day_booking_management`: today's service, the one a walk-in restaurant
 * actually runs on. `reservation` grants `booking_management` on top of it —
 * future-date bookings, the floor plan and the blacklist. Because the catalog
 * is cumulative, a reservation restaurant holds both capabilities, so full
 * access has to be tested first.
 */
export enum BookingScope {
  /** Every date range and every filter. */
  Full = "full",
  /** Today only: the date filters are not part of what was bought. */
  SameDay = "same_day",
  /** The module is not available at all. */
  None = "none",
}

export const resolveBookingScope = (
  restaurantCapabilities: string[] | undefined,
  owner: Owner | null,
): BookingScope => {
  if (isFeatureEnabled("booking_management", restaurantCapabilities, owner)) {
    return BookingScope.Full;
  }
  if (
    isFeatureEnabled(
      "same_day_booking_management",
      restaurantCapabilities,
      owner,
    )
  ) {
    return BookingScope.SameDay;
  }
  return BookingScope.None;
};

/** The features that reach the booking list, in the order they are tested. */
export const BOOKING_FEATURES = [
  "booking_management",
  "same_day_booking_management",
];
